import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsExtended() {
  const testimonials = [{
    initials: 'CR',
    name: 'Carlos R.',
    role: 'Papá separado',
    location: 'Ciudad de México',
    quote: 'El Batch Cooking me resolvió los domingos desde la primera semana.'
  }, {
    initials: 'FL',
    name: 'Florencia L.',
    role: 'Mamá separada',
    location: 'Montevideo',
    quote: 'Todo está organizado por situación: sé qué hacer sin pensar de más.'
  }, {
    initials: 'VT',
    name: 'Valentín T.',
    role: 'Papá separado',
    location: 'Santiago',
    quote: 'Es inclusivo, simple y funcionó desde el primer domingo.'
  }, {
    initials: 'JM',
    name: 'Jorge M.',
    role: 'Papá separado',
    location: 'Guatemala',
    quote: 'En dos horas dejo resuelta toda la semana.'
  }, {
    initials: 'PV',
    name: 'Patricia V.',
    role: 'Mamá separada',
    location: 'Quito',
    quote: 'Ahora gasto mejor y sé cuánto cuesta cada vianda.'
  }];
  return <section className="bg-cosmic-deep pt-2 md:pt-3 pb-3 md:pb-4 px-4" data-id="element-301" data-mp="26pu9qoj54cht">
      <div className="max-w-6xl mx-auto" data-id="element-302" data-mp="22oqua3508ih4">
        <h2 className="font-display font-bold text-center leading-tight mb-3 md:mb-4" data-id="element-303" data-mp="22ps4k5e750xs">
          <span className="block text-white text-base md:text-2xl" data-id="element-304" data-mp="1xqfmdxy9si1j">
            💬 Qué dicen los padres y madres separados
          </span>
          <span className="block text-gold text-base md:text-2xl" data-id="element-305" data-mp="2uf51jgiiiwjt">
            que ya tienen su MegaPack
          </span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-306" data-mp="2lncwxmg66hn5">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl p-2.5 md:p-3 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gold/20 flex flex-col" data-id="element-307" data-mp="2gpbdv1iquibo" data-mpi={i}>
              <div className="flex items-center gap-2 mb-1.5" data-id="element-308" data-mp="39cxec0wod6ub">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#2D0A6B] to-[#1a0533] flex items-center justify-center text-white font-bold text-[10px] shrink-0 border border-white/10" data-id="element-309" data-mp="3s9ftgp8hly6t">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-grow" data-id="element-310" data-mp="3jgcl2vcp8bj1">
                  <div className="font-bold text-white text-[11px] leading-tight" data-id="element-311" data-mp="3nipld48ofh8f">
                    {t.name}
                  </div>
                  <div className="text-white/60 text-[9px] leading-tight" data-id="element-312" data-mp="39hwq2hajwi49">
                    {t.role} | {t.location}
                  </div>
                </div>
                <div className="flex items-center gap-0.5 text-gold shrink-0" data-id="element-313" data-mp="30ijftmelrpih">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-2.5 h-2.5 fill-current" data-id="element-314" data-mp="34kwlkatcnnf9" data-mpi={j} />)}
                </div>
              </div>
              <p className="text-white/85 text-[11px] md:text-[12px] leading-snug italic" data-id="element-315" data-mp="yrofch9gb25f">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}